import { writable } from "svelte/store";
import { showCampaignTypes } from "./usersAndGroups.js";
import { getFromLocalStorage, saveToLocalStorage } from "./utils.js";

export const campaignTypeOptions = [
  { value: "allCampaigns", label: "All Campaign Types", default: true },
  { value: "candidateSourcing", label: "Candidate Sourcing" },
  { value: "businessDevelopment", label: "Business Development" },
];

const getCampaignTypeOption = () => {
  const defaultCampaignType = campaignTypeOptions.find(
    (option) => option.default === true,
  );
  if (!showCampaignTypes) {
    return defaultCampaignType;
  }
  return getFromLocalStorage("campaignType") || defaultCampaignType;
};

export const selectedCampaignType = writable(getCampaignTypeOption());

export const updateSelectedCampaignType = (type) => {
  selectedCampaignType.set(type);
  saveToLocalStorage("campaignType", type);
};
